// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { UseMutationOptions } from "@tanstack/react-query";
import { useMutationApi, useQueryApi } from "api/hooks.ts";
import { AxiosError } from "axios";
import { ApiErrorResponse } from "types/models.ts";

import { connectionSequenceStepApi } from "./api";

import GetConnectionSequenceStepsResponse = App.Http.Responses.ConnectionCreator.SequenceStep.GetConnectionSequenceStepsResponse;
import GetConnectionSequenceStepResponse = App.Http.Responses.ConnectionCreator.SequenceStep.GetConnectionSequenceStepResponse;
import StoreConnectionSequenceStepData = App.Http.Requests.ConnectionCreator.StoreConnectionSequenceStepData;
import DeleteConnectionSequenceStepRequest = App.Http.Requests.ConnectionCreator.StoreConnectionSequenceStepData;

// Query to get a list of connection sequence steps
export const useGetConnectionSequenceStepsQuery = (request, options = {}) => {
    return useQueryApi<GetConnectionSequenceStepsResponse>({
        queryKey: ["getConnectionSequenceSteps", request],
        queryFn: () => connectionSequenceStepApi.index(request),
        ...options,
    });
};

// Query to get a specific connection sequence step
export const useGetConnectionSequenceStepQuery = (stepId: string, options = {}) => {
    return useQueryApi<GetConnectionSequenceStepResponse>({
        queryKey: ["getConnectionSequenceStep", stepId],
        queryFn: () => connectionSequenceStepApi.show(stepId),
        ...options,
    });
};

// Mutation to store a new connection sequence step
export const useStoreConnectionSequenceStepMutation = (
    options: UseMutationOptions<
        GetConnectionSequenceStepResponse,
        AxiosError<ApiErrorResponse>,
        StoreConnectionSequenceStepData
    > = {}
) => {
    return useMutationApi<GetConnectionSequenceStepResponse, StoreConnectionSequenceStepData>({
        mutationKey: ["storeConnectionSequenceStep"],
        mutationFn: (request: StoreConnectionSequenceStepData) => connectionSequenceStepApi.store(request),
        ...options,
    });
};

// Mutation to update an existing connection sequence step
export const useUpdateConnectionSequenceStepMutation = (options = {}) => {
    return useMutationApi<GetConnectionSequenceStepResponse, StoreConnectionSequenceStepData>({
        mutationKey: ["updateConnectionSequenceStep"],
        mutationFn: (request: StoreConnectionSequenceStepData) => connectionSequenceStepApi.update(request, request.id),
        ...options,
    });
};

// Mutation to destroy a connection sequence step
export const useDestroyConnectionSequenceStepMutation = (options = {}) => {
    return useMutationApi<void, DeleteConnectionSequenceStepRequest>({
        mutationKey: ["destroyConnectionSequenceStep"],
        mutationFn: (stepId: string) => connectionSequenceStepApi.destroy(stepId),
        ...options,
    });
};
